<template>
  <div class="safe-view">
    <div class="user-view-main">
      <div class="list-item">
        <div class="list-item-left">
          <svg-icon icon-class="mima_" />
        </div>
        <div class="list-item-right list-item-line">
          <div>
            <p>登录密码</p>
            <p>建议定期更换</p>
          </div>
          <div>
            <p>
              安全性高的密码可以使账户更安全，建议您定期更换密码，且设置一个长度8-20位数的密码。
            </p>
          </div>
          <div>
            <small @click="passwordUpdate">修改</small>
          </div>
        </div>
      </div>
      <div class="list-item">
        <div class="list-item-left">
          <svg-icon icon-class="shoujitianchong" />
        </div>
        <div class="list-item-right">
          <div>
            <p>绑定手机</p>
            <p>{{ user.mobile }}</p>
          </div>
          <div>
            <p>
              绑定手机后，您即可享受手机号登录、找回密码等。为了账号安全，建议您在更换手机号后第一时间更换绑定手机。
            </p>
          </div>
          <div>
            <small @click="phoneUpdate">更换</small>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="修改密码"
      :visible.sync="passVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      @close="userDialogClose"
      width="576px"
    >
      <div class="dialog-view">
        <el-form
          :model="ruleForm"
          :rules="rules"
          class="user-ruleForm"
          ref="ruleForm"
          label-width="134px"
        >
          <el-form-item label="请输入当前密码:" prop="oldPassWord">
            <el-input
              v-model="ruleForm.oldPassWord"
              show-password
              autocomplete="off"
              auto-complete="new-password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="请输入新密码:" prop="password">
            <el-input
              v-model="ruleForm.password"
              show-password
              autocomplete="off"
              auto-complete="new-password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="请确认新密码:" prop="confirmPassword">
            <el-input
              v-model="ruleForm.confirmPassword"
              show-password
              autocomplete="off"
              auto-complete="new-password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passVisible = false" class="dialog-cancel">
          取 消
        </el-button>
        <el-button
          type="primary"
          class="dialog-determine"
          @click="passwordSave"
        >
          保 存
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="更改手机号"
      :visible.sync="phoneVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      @close="phoneDialogClose"
      width="576px"
    >
      <div class="dialog-view">
        <el-form
          :model="phoneRuleForm"
          :rules="phoneRules"
          class="user-ruleForm"
          ref="phoneRuleForm"
          label-width="134px"
        >
          <el-form-item label="请输入当前密码:" prop="password">
            <el-input
              v-model="phoneRuleForm.password"
              show-password
              auto-complete="new-password"
              autocomplete="off"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="请输入新手机号:" prop="phone">
            <el-input
              v-model="phoneRuleForm.phone"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码:" prop="code" class="custom-code-content">
            <el-input
              v-model="phoneRuleForm.code"
              placeholder="请输入验证码"
            ></el-input>
            <el-button
              type="primary"
              :disabled="!codeState || timeInterval ? true : false"
              :class="[!codeState || timeInterval ? 'customDisabled' : '']"
              @click="mobileClick"
            >
              {{ obtainCode }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="phoneVisible = false" class="dialog-cancel">
          取 消
        </el-button>
        <el-button type="primary" class="dialog-determine" @click="phoneSave">
          保 存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUpdatePassword, getReplacePhone } from "@/api/userCenter";
import { removeToken } from "@/utils/auth.js";
import { isRegister, getPhoneCode } from "@/api/app";
import { resetRouter } from "@/router";
import { mapGetters } from "vuex";
export default {
  name: "userSafe",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 8 || value.length > 20) {
        callback(new Error("密码长度需满足8-20位"));
      } else {
        if (this.ruleForm.confirmPassword !== "") {
          this.$refs.ruleForm.validateField("confirmPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    const validatePhone = async (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        this.codeState = false;
        callback(new Error("请输入正确手机号"));
      } else {
        let { data } = await isRegister({ number: value });
        if (data) {
          this.codeState = false;
          callback(new Error("手机号已注册,请重新输入"));
        } else {
          this.codeState = true;
          callback();
        }
      }
    };
    return {
      codeState: false,
      time_s: 60,
      timeInterval: null,
      obtainCode: "获取验证码",
      passVisible: false,
      phoneVisible: false,
      ruleForm: {
        oldPassWord: "",
        password: "",
        confirmPassword: ""
      },
      rules: {
        oldPassWord: [
          { required: true, message: "请输入当前密码", trigger: "blur" }
        ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur"
          }
        ],
        confirmPassword: [
          {
            required: true,
            validator: validatePass2,
            trigger: "blur"
          }
        ]
      },
      phoneRuleForm: {
        password: "",
        phone: "",
        code: ""
      },
      phoneRules: {
        password: [
          {
            required: true,
            validator: validatePass3,
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur"
          }
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      }
    };
  },
  computed: {
    ...mapGetters(["user"])
  },
  methods: {
    phoneUpdate() {
      this.phoneVisible = true;
    },
    phoneSave() {
      this.$refs["phoneRuleForm"].validate(async valid => {
        if (valid) {
          let params = Object.assign({}, this.phoneRuleForm);
          getReplacePhone(params)
            .then(res => {
              if (res.data) {
                this.$message({
                  message: "修改成功,请重新登录!",
                  type: "success"
                });
                removeToken();
                this.$store.commit("user/SET_NAME", "");
                resetRouter();
                this.$router.push(`/login`);
              }
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    passwordUpdate() {
      this.passVisible = true;
    },
    passwordSave() {
      this.$refs["ruleForm"].validate(async valid => {
        if (valid) {
          let params = Object.assign({}, this.ruleForm);
          getUpdatePassword(params)
            .then(res => {
              if (res.data) {
                this.$message({
                  message: "修改成功,请重新登录!",
                  type: "success"
                });
                removeToken();
                this.$store.commit("user/SET_NAME", "");
                resetRouter();
                this.$router.push(`/login`);
              }
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //关闭回调
    userDialogClose() {
      this.$refs["ruleForm"].resetFields();
    },
    phoneDialogClose() {
      this.$refs["phoneRuleForm"].resetFields();
    },
    async mobileClick() {
      let phoneCode = /^1[3456789]\d{9}$/;
      if (!phoneCode.test(this.phoneRuleForm.phone)) {
        this.$message.error("请输入正确手机号");
      } else {
        let { data } = await getPhoneCode({
          phoneNumber: this.phoneRuleForm.phone,
          templateId: "SMS_247795134"
        });
        console.log(data);
        this.timeInterval = setInterval(() => {
          this.obtainCode = this.time_s + "S后重试";
          this.time_s--;
          if (this.time_s < 0) {
            clearInterval(this.timeInterval);
            this.timeInterval = null;
            this.time_s = 60;
            this.obtainCode = "获取验证码";
          }
        }, 1000);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.safe-view {
  height: 100%;
  padding: 0 20px 0 20px;
}
.user-view-main {
  box-shadow: 0px 0px 16px 0px rgba(227, 236, 248, 0.72);
  border-radius: 12px;
  padding: 20px;
}
.list-item {
  display: flex;
  align-items: center;

  & .list-item-left {
    font-size: 24px;
    color: #1d6cea;
  }
  & .list-item-right {
    width: 0;
    flex: 1;
    margin-left: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 0;
    & > div {
      p {
        margin: 0;
        padding: 6px 0;
      }
      &:nth-of-type(1) {
        width: 0;
        flex: 1.2;
        & p {
          font-size: 14px;
          &:nth-of-type(1) {
            color: #312f2f;
          }
          &:nth-of-type(2) {
            color: #959595;
          }
        }
      }
      &:nth-of-type(2) {
        width: 0;
        flex: 1.2;
        p {
          font-size: 14px;
          color: #959595;
        }
      }
      &:nth-of-type(3) {
        padding-left: 60px;
        & small {
          font-size: 15px;
          color: #1d6cea;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
.list-item-line {
  border-bottom: 1px solid rgba(235, 235, 235, 0.5);
}
.user-ruleForm {
  ::v-deep {
    .el-input {
      width: 280px;
    }
    .el-form-item__label {
      font-size: 14px;
      color: #606266;
    }
  }
}
.custom-code-content {
  width: 414px;
}
.custom-code-content {
  ::v-deep {
    .el-form-item__content {
      width: auto;
    }
  }
}
</style>
